import common from './common'

export default {
	...common.button,
	color: `#2d3537`,
	border: '0',
	'::after': {
		...common.button['::after'],
		bg: `#f9b122`,
		borderColor: `alpha`
	}
}
